/* Gruzijos meno ir skonio namai — theme behaviour (own implementation). */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* event tickets are sold until the day in their title, Lithuanian time (snippet sz-event-end, data-event-end). The server
     leaves ended ones out, but Shopify may serve a cached page, so the browser checks again by its own clock (never by
     the address): ended list items and cards go before the lists below count and paginate them, the product page turns
     to "Renginys jau įvyko" like a sold-out one, and the cart drops such tickets (see dropEnded) */
  function vilniusToday() {
    var d = new Date(), p = {};
    try { new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Vilnius", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(d).forEach(function (x) { p[x.type] = x.value; }); } catch (e) {}
    return p.year ? p.year + "-" + p.month + "-" + p.day : d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
  }
  var TODAY = vilniusToday();
  function ended(day) { return !!day && day < TODAY; }
  $$("[data-event-end]").forEach(function (el) {
    if (!ended(el.getAttribute("data-event-end"))) return;
    if (el.hasAttribute("data-product")) {
      el.setAttribute("data-ended", "");
      var b = $(".sz-prod__btn", el), w = $(".sz-prod__qtyw", el);
      if (b) b.disabled = true;
      if (!w) return;
      w.classList.add("sz-prod__qtyw--disabled");
      $$("[data-qty]", w).forEach(function (q) { q.value = 0; });
      $$('[data-qty-step="1"]', w).forEach(function (q) { q.disabled = true; });
      var st = $(".sz-prod__stock", w);
      if (!st) { st = document.createElement("p"); st.className = "sz-prod__stock"; w.appendChild(st); }
      st.textContent = "Renginys jau įvyko";
      return;
    }
    var box = el.parentNode, rel = el.closest(".sz-prod__related");
    box.removeChild(el);
    // nothing left: the related block goes, a search result grid goes (the shop list shows its own empty state)
    if (rel && !$("[data-item]", rel)) rel.parentNode.removeChild(rel);
    else if (!box.children.length && box.classList.contains("sz-pl__grid") && !box.hasAttribute("data-pl-grid")) box.parentNode.removeChild(box);
  });

  /* header: transparent at the top, coloured + shadow once the page is scrolled */
  var top = $("[data-sz-top]"), header = $("[data-sz-header]");
  if (top && header && header.getAttribute("data-sticky") === "true") {
    top.classList.add("sz-top--sticky");
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 0); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }
  /* the desktop header grows when the menu wraps (narrow desktops); the first block under it follows */
  function syncHeaderHeight() {
    var h = $(".sz-header");
    if (!h || window.innerWidth <= 920) return;
    var d = $(".sz-header__desk", h);
    if (d) document.documentElement.style.setProperty("--hh", Math.max(d.offsetHeight, 0) + "px");
  }
  syncHeaderHeight();
  window.addEventListener("resize", syncHeaderHeight);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeaderHeight);

  /* mobile menu */
  $$("[data-burger]").forEach(function (b) {
    b.addEventListener("click", function () {
      var open = !header.classList.contains("is-open");
      header.classList.toggle("is-open", open); b.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.classList.toggle("sz-noscroll", open);
    });
  });
  function menuClose(instant) {
    if (!header || !header.classList.contains("is-open")) return;
    var dd = $("[data-dropdown]", header);
    if (instant && dd) dd.style.transition = "none";
    header.classList.remove("is-open"); document.documentElement.classList.remove("sz-noscroll");
    $$("[data-burger]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    if (instant && dd) { void dd.offsetWidth; dd.style.transition = ""; }
  }
  // like the original, a tapped menu link closes the menu before the page changes (so Back never returns to an open menu)
  $$("[data-dropdown] a").forEach(function (a) {
    a.addEventListener("click", function (e) { if (!e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) menuClose(); });
  });

  /* reveal animations, like the original: an element switches on once its (shifted) box enters the viewport; at the
     first look its own unshifted box counts, so blocks already on screen at load (even very tall ones, whose shifted
     box is still below the fold) never stay hidden */
  var anim = $$(".sz-anim"), io = null;
  function shiftY(el) { var t = getComputedStyle(el).transform; return t && t !== "none" && window.DOMMatrix ? new DOMMatrix(t).m42 : 0; }
  function reveal(el) {
    // nested ones (related cards inside the product block) start with their block, as on the original
    $$(".sz-anim", el).forEach(function (c) { if (!c.classList.contains("is-in")) { if (io) io.unobserve(c); reveal(c); } });
    // pictures switch on once loaded (the original waits for its image "loaded" flag)
    var im = el.matches(".sz-e--img, .sz-gal__item, .sz-ig__item") ? $$("img", el).filter(function (i) { return !i.complete && i.getClientRects().length; }) : [];
    var n = im.length, done = function () { if (--n <= 0) el.classList.add("is-in"); };
    if (!n) { el.classList.add("is-in"); return; }
    im.forEach(function (i) { i.addEventListener("load", done); i.addEventListener("error", done); });
  }
  if ("IntersectionObserver" in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var el = e.target, r = e.boundingClientRect, on = e.isIntersecting, first = !el._szSeen;
        el._szSeen = true;
        if (el._szRearm) { el._szRearm = false; if (on) io.unobserve(el); else el.classList.remove("is-in"); return; }
        if (!on && first && (r.width || r.height)) { var t = r.top - shiftY(el); on = t < innerHeight && t + r.height > 0; }
        if (on) { io.unobserve(el); reveal(el); }
      });
    });
    anim.forEach(function (el) { io.observe(el); });
  } else { anim.forEach(function (el) { el.classList.add("is-in"); }); }
  /* cards shown later by pagination, category or sorting: like the original they appear at once (no animation); once the
     list has scrolled into place, the ones off screen hide again and slide in when scrolled to */
  function rearm(els) {
    els = els.filter(function (el) { return el.getClientRects().length; });
    if (!io || !els.length) return;
    els.forEach(function (el) { io.unobserve(el); el.style.transition = "none"; el.classList.add("is-in"); });
    void els[0].offsetWidth;
    els.forEach(function (el) { el.style.transition = ""; });
    var y = NaN, n = 0;
    requestAnimationFrame(function wait() {
      if (scrollY !== y) { y = scrollY; n = 0; } else if (++n > 2) { els.forEach(function (el) { el._szRearm = true; io.observe(el); }); return; }
      requestAnimationFrame(wait);
    });
  }
  // the lists below show/hide their items with [hidden]; watch that only after their first render
  setTimeout(function () {
    if (!io || !window.MutationObserver) return;
    var mo = new MutationObserver(function (ms) {
      var els = [];
      ms.forEach(function (m) {
        var t = m.target; if (t.hidden) return;
        (t.classList.contains("sz-anim") ? [t] : $$(".sz-anim", t)).forEach(function (el) { if (els.indexOf(el) < 0) els.push(el); });
      });
      rearm(els);
    });
    $$("[data-product-list], [data-blog-list]").forEach(function (l) { mo.observe(l, { subtree: true, attributes: true, attributeFilter: ["hidden"] }); });
  }, 0);

  /* gallery / image lightbox, like the original: a click in a side column steps, anywhere else outside the picture closes;
     arrows + Esc; a swipe (touch anywhere) or dragging the picture steps, the first move decides; body scroll locked */
  var lb, lbItems = [], lbCur = 0, lbT;
  function lbOpen() { return lb && lb.classList.contains("is-open"); }
  function lbShow(d) {
    var img = $(".sz-lb__img", lb);
    lbCur = (lbCur + d + lbItems.length) % lbItems.length;
    clearTimeout(lbT);
    if (!d) { img.classList.remove("is-out"); img.src = lbItems[lbCur]; return; }
    // out-in: the old picture fades out, then (two frames later, as Vue does) the new one fades in, .15s each
    img.classList.add("is-out");
    lbT = setTimeout(function () {
      var n = lbCur; img.src = lbItems[n];
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (n === lbCur) img.classList.remove("is-out"); }); });
    }, 150);
  }
  function lbClose() { clearTimeout(lbT); lb.classList.remove("is-open"); document.body.style.overflow = ""; }
  function openLightbox(items, index) {
    if (!lb) {
      lb = document.createElement("div"); lb.className = "sz-lb"; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true");
      lb.innerHTML = '<button type="button" class="sz-lb__btn sz-lb__x" title="close-ligthbox-button" aria-label="Uždaryti"></button><div class="sz-lb__c">' +
        '<div class="sz-lb__nav"><button type="button" class="sz-lb__btn sz-lb__prev" aria-label="Atgal"></button></div><img class="sz-lb__img" alt="">' +
        '<div class="sz-lb__nav"><button type="button" class="sz-lb__btn sz-lb__next" aria-label="Pirmyn"></button></div></div>';
      document.body.appendChild(lb);
      var img = $(".sz-lb__img", lb), navs = $$(".sz-lb__nav", lb), sx = null, sy = 0;
      lb.addEventListener("click", function (e) {
        var n = e.target.closest(".sz-lb__nav");
        if (n) lbShow(n === navs[0] ? -1 : 1); else if (e.target !== img) lbClose();
      });
      document.addEventListener("keydown", function (e) {
        if (!lbOpen()) return;
        if (e.key === "Escape") lbClose();
        if (e.key === "ArrowLeft") lbShow(-1); if (e.key === "ArrowRight") lbShow(1);
      });
      function move(x, y) { if (sx === null) return; var dx = sx - x, dy = sy - y; sx = null; if (Math.abs(dx) > Math.abs(dy)) lbShow(dx > 0 ? 1 : -1); }
      document.addEventListener("touchstart", function (e) { if (lbOpen()) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive: true });
      document.addEventListener("touchmove", function (e) { if (lbOpen()) move(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      img.addEventListener("dragstart", function (e) {
        var t = new Image(); t.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
        if (e.dataTransfer) e.dataTransfer.setDragImage(t, 0, 0);
        sx = e.clientX; sy = e.clientY;
      });
      img.addEventListener("drag", function (e) { move(e.clientX, e.clientY); });
    }
    lbItems = items; lbCur = index; lb.classList.toggle("sz-lb--single", items.length < 2);
    lbShow(0); lb.classList.add("is-open"); document.body.style.overflow = "hidden";
  }
  $$(".sz-gal[data-lightbox='1']").forEach(function (g) {
    var items = $$(".sz-gal__item", g).map(function (b) { return b.getAttribute("data-full"); });
    $$(".sz-gal__item", g).forEach(function (b, i) { b.addEventListener("click", function () { openLightbox(items, i); }); });
  });
  // single images with the "lightbox" click action
  $$(".sz-img--lb").forEach(function (d) { d.addEventListener("click", function () { openLightbox([d.getAttribute("data-full")], 0); }); });

  /* blog list pagination (client side, like the original): ?page=N with a history entry (Back/reload keep the page), the
     current page and the end arrows are disabled, a click jumps the block under the sticky header */
  $$("[data-blog-list]").forEach(function (bl) {
    var pages = +bl.getAttribute("data-pages") || 1, cur = 1;
    function urlPage() { return parseInt(new URLSearchParams(location.search).get("page"), 10) || 1; }
    function go(p) {
      cur = Math.min(Math.max(1, p), pages);
      $$(".sz-bl__item", bl).forEach(function (it) { it.hidden = +it.getAttribute("data-page") !== cur; });
      $$(".sz-pag__btn", bl).forEach(function (b) {
        var g = b.getAttribute("data-goto"), off = g ? +g === cur : (b.getAttribute("data-step") === "-1" ? cur === 1 : cur === pages);
        b.disabled = off;
        if (g) { b.classList.toggle("is-current", off); if (off) b.setAttribute("aria-current", "page"); else b.removeAttribute("aria-current"); }
      });
    }
    $$(".sz-pag__btn", bl).forEach(function (b) {
      b.addEventListener("click", function () {
        go(b.hasAttribute("data-goto") ? +b.getAttribute("data-goto") : cur + (+b.getAttribute("data-step")));
        var u = new URL(location.href); u.searchParams.set("page", cur); history.pushState(null, "", u.toString());
        var sec = bl.closest("section") || bl, t = $("[data-sz-top]");
        var off = t && getComputedStyle(t).position === "sticky" ? t.getBoundingClientRect().bottom : 0;
        window.scrollTo({ top: sec.getBoundingClientRect().top + scrollY - off, behavior: "instant" });
      });
    });
    window.addEventListener("popstate", function () { go(urlPage()); });
    go(urlPage());
  });

  /* map: stop the placeholder shimmer once the iframe has loaded */
  $$(".sz-map iframe").forEach(function (f) { f.addEventListener("load", function () { f.parentNode.classList.add("is-loaded"); }); });

  /* forms: the original's own validation instead of the browser bubble. A submit trims the fields and checks them all;
     with errors every bad field turns red with its message under it and nothing is sent (no scrolling, focus stays).
     From then on each field re-checks while typing. */
  var EMAIL_RE;
  try { EMAIL_RE = new RegExp("^[\\p{L}\\p{N}+._&-]{1,80}@[\\p{L}\\p{N}.-]{1,80}\\.[A-Za-z]{1,15}$", "u"); } catch (e) { EMAIL_RE = /^[^\s@]{1,80}@[^\s@]{1,80}\.[A-Za-z]{1,15}$/; }
  $$(".sz-form form").forEach(function (f) {
    var shown = false, fields = $$(".sz-in__c", f);
    f.noValidate = true;
    function check(x) {
      var v = x.value, msg = "";
      if (x.hasAttribute("data-msg-req") && !v.replace(/ /g, "")) msg = x.getAttribute("data-msg-req");
      else if (v.replace(/ /g, "") && x.hasAttribute("data-msg-email") && !EMAIL_RE.test(v)) msg = x.getAttribute("data-msg-email");
      var p = x.parentNode.querySelector(".sz-in__err");
      x.classList.toggle("sz-in__c--err", !!msg);
      if (msg) { if (!p) { p = document.createElement("p"); p.className = "sz-in__err"; x.parentNode.insertBefore(p, x.nextSibling); } p.textContent = msg; }
      else if (p) p.parentNode.removeChild(p);
      return !msg;
    }
    fields.forEach(function (x) { x.addEventListener("input", function () { if (shown) check(x); }); });
    f.addEventListener("submit", function (e) {
      var bad = fields.filter(function (x) { x.value = x.value.trim(); return !check(x); });
      shown = bad.length > 0;
      if (shown) e.preventDefault();
    });
  });

  /* product list: category, search, sorting and pagination in the browser (like the original) */
  // the original only knows "produktas" (n <= 1) and "produktai"
  function plural(n) { return n + (n > 1 ? " produktai" : " produktas"); }
  var ARROW_L = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_R = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  $$("[data-product-list]").forEach(function (pl) {
    var per = +pl.getAttribute("data-per-page") || 6;
    var grid = $("[data-pl-grid]", pl), pag = $("[data-pl-pag]", pl);
    var items = $$("[data-item]", grid);
    var sec = pl.closest("section"), hasCats = !!$("[data-cat-list]", pl);
    /* address like the original: the category is the page (/collections/<handle>, = the link's href), the list page is
       ?store-page-<block id>=N; every change is a history entry and Back/Forward restore both */
    var pkey = sec && sec.id ? "store-page-" + sec.id : null;
    function fromUrl() {
      var q = new URLSearchParams(location.search), m = hasCats && location.pathname.match(/\/collections\/([^\/?#]+)/);
      return { cat: (hasCats && q.get("kategorija")) || (m && decodeURIComponent(m[1])) || pl.getAttribute("data-initial") || "all",
               page: Math.max(1, parseInt(pkey && q.get(pkey), 10) || 1) };
    }
    function pushUrl() {
      var u = new URL(location.href);
      if (hasCats) { u.pathname = state.cat === "all" ? "/collections/all" : "/collections/" + state.cat; u.searchParams.delete("kategorija"); }
      if (pkey) { if (state.page > 1) u.searchParams.set(pkey, state.page); else u.searchParams.delete(pkey); }
      if (u.href !== location.href) history.pushState(null, "", u.href);
    }
    var state = fromUrl(); state.sort = "";
    function catTitle(c) {
      var o = $("[data-cat-select] option[value='" + c + "']", pl);
      return o ? o.textContent : (c === "all" ? "Visi produktai" : "");
    }
    /* default order: the store's own order per category (metafield skonis.sort), else the collection order */
    function pos(it, c) {
      var s = it._sort;
      if (s === undefined) { try { s = JSON.parse(it.getAttribute("data-sort") || "null"); } catch (e) { s = null; } it._sort = s; }
      c = c || state.cat;
      return s && s[c] != null ? +s[c] : 10000 + (+it.getAttribute("data-index"));
    }
    function osort(it, i) {
      var o = it._os;
      if (o === undefined) { o = {}; (it.getAttribute("data-osort") || "").split(" ").forEach(function (p) { var kv = p.split(":"); if (kv[1]) o[kv[0]] = kv[1].split(",").map(Number); }); it._os = o; }
      return o[state.cat] ? o[state.cat][i] : 0;
    }
    // search ignores case and Lithuanian diacritics ("staltiese" finds "Staltiesė")
    function fold(s) { return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    function render() {
      var list = items.filter(function (it) {
        var cols = (it.getAttribute("data-collections") || "").split(",");
        return state.cat === "all" || cols.indexOf(state.cat) > -1;
      });
      // equal prices and "Naujausi" follow the original's own order in this category (data-osort); products it did not
      // have: newest first / after the known ones in the default order
      var tie = function (it, i) { return osort(it, i) || 10000 + pos(it); };
      var key = { "price-asc": function (a, b) { return a.getAttribute("data-price") - b.getAttribute("data-price") || tie(a, 0) - tie(b, 0); },
                  "price-desc": function (a, b) { return b.getAttribute("data-price") - a.getAttribute("data-price") || tie(a, 1) - tie(b, 1); },
                  "created-desc": function (a, b) { var x = osort(a, 2), y = osort(b, 2); return (x > 0) - (y > 0) || (x ? x - y : b.getAttribute("data-created") - a.getAttribute("data-created")); } }[state.sort]
                || function (a, b) { return pos(a) - pos(b); };
      list.sort(key);
      var pages = Math.max(1, Math.ceil(list.length / per));
      state.page = Math.min(state.page, pages);
      items.forEach(function (it) { it.hidden = true; });
      list.forEach(function (it, i) { grid.appendChild(it); it.hidden = Math.floor(i / per) + 1 !== state.page; });
      $$("[data-pl-count]", pl).forEach(function (c) { c.textContent = plural(list.length); });
      var empty = $("[data-pl-empty]", pl), none = list.length === 0;
      if (empty) { empty.hidden = !none; grid.hidden = none; if (pag) pag.hidden = none; var hd = $(".sz-pl__hdr", pl); if (hd) hd.hidden = none; }
      var t = $("[data-cat-title]", pl); if (t) t.textContent = catTitle(state.cat);
      $$("[data-cat]", pl).forEach(function (a) { a.classList.toggle("is-active", a.getAttribute("data-cat") === state.cat); });
      var sel = $("[data-cat-select]", pl); if (sel) sel.value = state.cat;
      if (pag) {
        if (pages > 1) {
          var h = '<div class="sz-pag product-list-pagination"><button type="button" class="sz-pag__btn" data-step="-1" aria-label="Ankstesnis puslapis"' + (state.page === 1 ? " disabled" : "") + ">" + ARROW_L + "</button>";
          for (var p = 1; p <= pages; p++) h += '<button type="button" class="sz-pag__btn sz-pag__num' + (p === state.page ? " is-current" : "") + '" data-goto="' + p + '" aria-label="Eiti į puslapį ' + p + '"' + (p === state.page ? ' aria-current="page" disabled' : "") + ">" + p + "</button>";
          h += '<button type="button" class="sz-pag__btn" data-step="1" aria-label="Kitas puslapis"' + (state.page === pages ? " disabled" : "") + ">" + ARROW_R + "</button></div>";
          pag.innerHTML = h;
        } else pag.innerHTML = "";
      }
      ttUpd();
    }
    /* to-top button, like the original: shown once the card at index (cols-1)*cols of the current page is within the
       original's computed image height (not the real one) of the window top; never when that card does not exist */
    var tt = $("[data-totop]", pl);
    function ttUpd() {
      if (!tt) return;
      var cols = innerWidth <= 920 ? 1 : (+getComputedStyle(pl).getPropertyValue("--cols") || 3);
      var mk = $$("[data-item]", grid).filter(function (i) { return !i.hidden; })[(cols - 1) * cols];
      var on = false;
      if (mk) {
        var cs = getComputedStyle(pl), gap = parseFloat(cs.getPropertyValue("--gap")) || 0, im = $(".sz-pli__img", mk);
        var w = pl.classList.contains("sz-pl--full") ? pl.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) : 1224;
        var r = im && im.classList.contains("sz-pli__img--portrait") ? 1.25 : im && im.classList.contains("sz-pli__img--landscape") ? 9 / 16 : 1;
        on = Math.round(mk.getBoundingClientRect().top + scrollY) <= scrollY + Math.floor(Math.floor((w - (cols - 1) * gap - (hasCats ? 200 : 0)) / cols) * r);
      }
      tt.classList.toggle("is-hidden", !on);
    }
    if (tt) { window.addEventListener("scroll", ttUpd, { passive: true }); window.addEventListener("resize", ttUpd); }
    // category change: like the original, the list block is scrolled to just under the sticky header (also when unchanged)
    function setCat(c) {
      if (c !== state.cat) { state.cat = c; state.page = 1; pushUrl(); render(); }
      var top = $("[data-sz-top]"), off = top && top.classList.contains("sz-top--sticky") ? top.offsetHeight : 0;
      var y = (sec || pl).getBoundingClientRect().top + scrollY - off;
      requestAnimationFrame(function () { window.scrollTo({ top: y, behavior: "smooth" }); });
    }
    if (hasCats || pkey) window.addEventListener("popstate", function () {
      var s = fromUrl();
      if (s.cat !== state.cat || s.page !== state.page) { state.cat = s.cat; state.page = s.page; render(); }
    });
    pl.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cat]");
      if (a) { e.preventDefault(); setCat(a.getAttribute("data-cat")); return; }
      var b = e.target.closest(".sz-pag__btn");
      if (b && pag.contains(b)) { state.page = b.hasAttribute("data-goto") ? +b.getAttribute("data-goto") : state.page + (+b.getAttribute("data-step")); pushUrl(); render(); pl.scrollIntoView({ behavior: "smooth" }); return; }
      if (e.target.closest("[data-totop]")) pl.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    $$("[data-cat-select]", pl).forEach(function (s) { s.addEventListener("change", function () { setCat(s.value); }); });
    $$("[data-pl-sort]", pl).forEach(function (s) { s.addEventListener("change", function () { state.sort = s.value; state.page = 1; $$("[data-pl-sort]", pl).forEach(function (o) { o.value = s.value; }); render(); }); });
    /* search: like the original, a list of matching products opens under the field (picture, title with the match
       in bold, price, or "Rezultatų nerasta"); the grid, category and sorting stay as they are */
    function marked(title, q) {
      var f = "", map = [], out = "", last = 0, k = 0;
      for (var i = 0; i < title.length; i++) { var c = fold(title[i]); for (var j = 0; j < c.length; j++) { f += c[j]; map.push(i); } }
      while (q && (k = f.indexOf(q, k)) > -1) {
        var a = map[k], b = map[k + q.length - 1] + 1;
        if (a >= last) { out += esc(title.slice(last, a)) + "<mark>" + esc(title.slice(a, b)) + "</mark>"; last = b; }
        k += q.length;
      }
      return out + esc(title.slice(last));
    }
    $$("[data-pl-searchbox]", pl).forEach(function (box) {
      var inp = $("[data-pl-search]", box), dd = $("[data-pl-dd]", box), ul = $("ul", dd), x = $("[data-pl-search-close]", box);
      var hl = -1; // highlighted result (arrow keys / mouse / focus), Enter opens it
      function links() { return $$(".sz-search__item", ul); }
      function setHl(i) { hl = i; links().forEach(function (a, k) { a.classList.toggle("is-hl", k === i); a.parentNode.setAttribute("aria-selected", k === i ? "true" : "false"); }); }
      function close() { dd.hidden = true; x.hidden = true; inp.setAttribute("aria-expanded", "false"); }
      function update() {
        var raw = inp.value.trim(), q = fold(raw);
        if (!q) { close(); return; }
        // like the original: at most 15 results, in the shop's default order
        var hits = items.filter(function (it) { return fold($(".sz-pli__title", it).textContent).indexOf(q) > -1; })
          .sort(function (a, b) { return pos(a, "all") - pos(b, "all"); }).slice(0, 15);
        ul.innerHTML = hits.length ? hits.map(function (it) {
          var img = $(".sz-pli__im", it), title = $(".sz-pli__title", it).textContent.trim();
          return '<li role="option" aria-selected="false"><a class="sz-search__item" href="' + esc(it.getAttribute("href")) + '">' +
            (img ? '<img class="sz-search__img" src="' + esc(img.getAttribute("src").replace(/([?&](?:width|height)=)\d+/g, "$196")) + '" alt="' + esc(title) + '" width="48" height="48" loading="lazy">' : "") +
            '<span class="sz-search__content"><span class="sz-search__title">' + marked(title, q) + "</span>" +
            ($(".sz-pli__soldout", it) ? '<span class="sz-search__price sz-search__soldout">' + esc($(".sz-pli__soldout", it).textContent.trim()) + '</span>'
              : '<span class="sz-search__price">€' + (it.getAttribute("data-price") / 100).toFixed(2) + "</span>") + "</span></a></li>";
        }).join("") : '<p class="sz-search__none">Rezultatų nerasta</p>';
        setHl(hl); // the original keeps the highlighted position while the results change
        dd.hidden = false; x.hidden = false; inp.setAttribute("aria-expanded", "true");
      }
      // closing by the X or a click elsewhere also empties the field (original)
      function reset() { inp.value = ""; setHl(-1); close(); }
      inp.addEventListener("input", update);
      inp.addEventListener("focus", update);
      inp.addEventListener("keydown", function (e) {
        var n = dd.hidden ? 0 : links().length;
        if (e.key === "ArrowDown" && !dd.hidden) { e.preventDefault(); if (hl < n - 1) setHl(hl + 1); }
        else if (e.key === "ArrowUp" && !dd.hidden) { e.preventDefault(); if (hl > 0) setHl(hl - 1); }
        else if (e.key === "Enter" && hl > -1 && hl < n) { e.preventDefault(); links()[hl].click(); }
        else if (e.key === "Escape") close();
      });
      ul.addEventListener("mouseover", function (e) { var a = e.target.closest(".sz-search__item"); if (a) setHl(links().indexOf(a)); });
      ul.addEventListener("focusin", function (e) { var a = e.target.closest(".sz-search__item"); if (a) setHl(links().indexOf(a)); });
      x.addEventListener("click", function () { reset(); inp.focus(); });
      document.addEventListener("click", function (e) { if (!box.contains(e.target)) reset(); });
    });
    render();
  });

  /* product page: image carousel (main image, thumbnails window of 8, dots, swipe) */
  /* how many thumbnails: the original's table by window width (gallery under the picture; at <= 920 the strip is hidden) */
  function thumbsFit() { var w = window.innerWidth; return w < 900 ? 4 : w < 1020 ? 5 : w < 1160 ? 6 : w < 1320 ? 7 : 8; }
  $$("[data-carousel]").forEach(function (car) {
    var FIT = thumbsFit(), lw = window.innerWidth;
    var imgs = $$(".sz-car__img", car), thumbs = $$(".sz-car__thumb", car), dots = $$(".sz-car__dot", car), len = thumbs.length;
    var tl = $("[data-car-tstep='-1']", car), tr = $("[data-car-tstep='1']", car);
    var cur = 0, start = 0;
    // like the original: one thumbnail fewer while the strip is scrolled into the middle (left arrow shown, more on the right)
    function vis() { return start !== 0 && start + FIT < len ? FIT - 1 : FIT; }
    function preset() { start = len - cur < vis() ? len - vis() : cur; } // the current picture first (or the strip at its end)
    function window_() {
      var n = vis();
      thumbs.forEach(function (t, i) { t.hidden = i < start || i >= start + n; t.classList.toggle("is-last", i === Math.min(len, start + n) - 1); });
      if (tl) tl.hidden = start === 0;
      if (tr) tr.hidden = len < n || start + n >= len;
    }
    // the next and previous pictures load ahead (lazy pictures in display:none never would), so a swipe never shows an empty box
    function warm(k) { var im = imgs[(k + imgs.length) % imgs.length]; if (im) im.removeAttribute("loading"); }
    function show() { imgs.forEach(function (im, k) { im.classList.toggle("is-active", k === cur); }); }
    function go(i, d) {
      cur = (i + imgs.length) % imgs.length;
      var im = imgs[cur], want = cur;
      warm(cur); warm(cur + 1); warm(cur - 1);
      // a picture still loading: the previous one stays until it is there
      if (im.complete) show(); else { var done = function () { if (cur === want) show(); }; im.addEventListener("load", done); im.addEventListener("error", done); }
      thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === cur); });
      dots.forEach(function (t, k) { t.classList.toggle("is-active", k === cur); });
      // strip position as on the original: next past the end wraps to the start, else the current picture comes first
      if (len && !(cur >= start && cur < start + vis())) {
        if (d > 0) { if (start + vis() === len) start = 0; else { preset(); if (len - start < vis()) preset(); } }
        else if (d < 0 && start === 0) start = len - vis();
        else preset();
      }
      window_();
    }
    // strip arrows: right moves one (twice when the step itself took a thumbnail away), left moves one
    function stepRight() { var n = vis(); start++; if (n !== vis() && start + vis() < len) stepRight(); }
    car.addEventListener("click", function (e) {
      var b = e.target.closest("[data-car-step],[data-car-go],[data-car-tstep]");
      if (!b) return;
      if (b.hasAttribute("data-car-step")) { var s = +b.getAttribute("data-car-step"); go(cur + s, s); }
      else if (b.hasAttribute("data-car-go")) go(+b.getAttribute("data-car-go"), 0);
      else { if (+b.getAttribute("data-car-tstep") > 0) { if (start + vis() < len) stepRight(); } else start = Math.max(0, start - 1); window_(); }
    });
    var x0 = null, warmed = false;
    function warmUp() { if (!warmed) { warmed = true; warm(cur + 1); warm(cur - 1); } }
    car.addEventListener("touchstart", function (e) { warmUp(); x0 = e.touches[0].clientX; }, { passive: true });
    car.addEventListener("pointerenter", warmUp);
    car.addEventListener("focusin", warmUp);
    car.addEventListener("touchend", function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40 && imgs.length > 1) go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    window_();
    // like the original a resize recounts and, when not all fit, puts the current picture first (only on width changes)
    window.addEventListener("resize", function () {
      if (window.innerWidth === lw) return; lw = window.innerWidth; FIT = thumbsFit();
      if (vis() < len) preset(); window_();
    });
  });

  /* product page: quantity, options (variants), additional info accordions */
  var REDUCE = function () { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); };
  $$("[data-product]").forEach(function (pr) {
    var qty = $("[data-qty]", pr), plus = $('[data-qty-step="1"]', pr);
    // like the original picker: a sold-out product/variant shows 0 and cannot be raised; at most 250
    var soldOut = function () { return !!(plus && plus.disabled); };
    var clampQ = function (n) { return Math.min(250, Math.max(1, n)); };
    $$("[data-qty-step]", pr).forEach(function (b) {
      b.addEventListener("click", function () { if (!qty) return; qty.value = soldOut() ? 0 : clampQ((parseInt(qty.value, 10) || 1) + (+b.getAttribute("data-qty-step"))); });
    });
    if (qty) qty.addEventListener("change", function () { qty.value = soldOut() ? 0 : clampQ(parseInt(qty.value, 10) || 1); });
    var vj = $("[data-variants]", pr), variants = [];
    try { variants = JSON.parse(vj ? vj.textContent : "[]"); } catch (e) {}
    var money = function (c) { return "€" + (c / 100).toFixed(2); };
    $$("[data-option]", pr).forEach(function (sel) {
      sel.addEventListener("change", function () {
        var chosen = $$("[data-option]", pr).map(function (s) { return s.value; });
        var v = variants.filter(function (x) { return chosen.every(function (val, i) { return x.options[i] === val; }); })[0];
        if (!v) return;
        var id = $("[data-variant-id]", pr), add = $(".sz-prod__btn", pr), price = $("[data-price]", pr);
        var off = v.available === false || pr.hasAttribute("data-ended"); // an event that is over stays off in every variant
        if (id) id.value = v.id;
        if (add) { add.setAttribute("data-add", v.id); add.setAttribute("data-unit", v.price); add.setAttribute("data-vtitle", v.title); add.disabled = off; }
        if (plus) plus.disabled = off;
        if (qty) qty.value = off ? 0 : clampQ(parseInt(qty.value, 10) || 1);
        if (price) price.textContent = money(v.price);
      });
    });
    /* additional info, like the original: one section open at a time, the height animates (.3s; closing also fades), and
       200ms after opening the tapped button scrolls to the middle of the window; tapping the open one only closes it */
    var ais = $$("[data-ai]", pr);
    function aiSet(b, open) {
      var p = document.getElementById(b.getAttribute("aria-controls"));
      b.setAttribute("aria-expanded", open ? "true" : "false");
      $(".sz-ai__icon", b).classList.toggle("is-active", open);
      if (!p || (p.hidden === !open && !p._szT)) return;
      clearTimeout(p._szT); p._szT = 0;
      if (REDUCE()) { p.classList.remove("is-anim"); p.style.height = p.style.opacity = ""; p.hidden = !open; return; }
      var h = p.hidden ? 0 : p.offsetHeight;
      p.hidden = false; p.classList.add("is-anim"); p.style.height = h + "px"; p.style.opacity = open ? "" : "1";
      void p.offsetHeight;
      p.style.height = (open ? p.scrollHeight : 0) + "px"; if (!open) p.style.opacity = "0";
      p._szT = setTimeout(function () { p._szT = 0; p.classList.remove("is-anim"); p.style.height = p.style.opacity = ""; p.hidden = !open; }, 300);
    }
    ais.forEach(function (b) {
      b.addEventListener("click", function () {
        var open = b.getAttribute("aria-expanded") !== "true";
        ais.forEach(function (o) { if (o !== b && o.getAttribute("aria-expanded") === "true") aiSet(o, false); });
        aiSet(b, open);
        if (open) setTimeout(function () { b.scrollIntoView({ behavior: REDUCE() ? "auto" : "smooth", block: "center" }); }, 200);
      });
    });
  });

  /* cart drawer (Shopify AJAX cart: /cart.js, /cart/change.js) */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var cd = $("[data-cart-drawer]"), cbody = $("[data-cart-body]");
  var ICON_MINUS = '<svg viewBox="0 0 16 16" fill="none"><path d="M5.33325 7.99998H10.6666M14.6666 7.99998C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99998C1.33325 4.31808 4.31802 1.33331 7.99992 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 16 16" fill="none"><path d="M7.99992 5.33334V10.6667M5.33325 8.00001H10.6666M14.6666 8.00001C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00001C1.33325 4.31811 4.31802 1.33334 7.99992 1.33334C11.6818 1.33334 14.6666 4.31811 14.6666 8.00001Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 16 16" fill="none"><path d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4M6.66667 7V10.3333M9.33333 7V10.3333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"/></svg>';
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function eur(c) { return "€" + (c / 100).toFixed(2); }
  function imgW(u, w) { return u ? u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w : ""; }
  /* the original keeps its cart in the browser, so every change shows at once: the drawer draws the expected cart
     right away and the store's cart once the last queued request has answered. SRC keeps one picture URL per variant
     so redrawing never reloads it. */
  var lastCart = { items: [], item_count: 0, total_price: 0 }, SRC = {}, cartQ = Promise.resolve(), cartN = 0;
  // video lessons are bought once: no quantity in the cart, like on the original. Event tickets (sent by e-mail) and the
  // gift card need no shipping either but keep it, so the product type tells (Shopify's product_type of the line)
  var VIDEO = "Video pamoka";
  function isDigital(it) { return it.product_type === VIDEO; }
  /* an event ticket whose day is over leaves the cart (the store is asked to remove it) with a short note, before checkout;
     EV = last sale day per ticket variant (snippet sz-cart-drawer). The /cart page is drawn again once the store has it. */
  var EV = {}, evGone = {}, evNote = false, evBack = false, NOTE_EV = "Renginys jau įvyko – bilietas pašalintas iš krepšelio";
  try { EV = JSON.parse($("[data-event-ends]").textContent) || {}; } catch (e) {}
  function isEnded(it) { return ended(EV[it.variant_id || it.id]); }
  function dropEnded(cart) {
    var gone = (cart.items || []).filter(isEnded);
    if (!gone.length) return cart;
    evNote = true;
    var c = { items: [], item_count: 0, total_price: cart.total_price || 0 };
    cart.items.forEach(function (it) { if (gone.indexOf(it) > -1) c.total_price -= it.final_line_price || it.final_price * it.quantity; else { c.items.push(it); c.item_count += it.quantity; } });
    gone.forEach(function (it) {
      var k = it.key || it.id;
      if (evGone[k]) return;
      evGone[k] = 1;
      sync(function () {
        return post("cart/change.js", { id: k, quantity: 0 }).then(function (r) {
          // (once: a page drawn again after such a removal never reloads itself)
          if ($(".sz-cartpage") && !evBack) { try { sessionStorage.setItem("sz-ev-note", "1"); } catch (e) {} location.reload(); }
          return r;
        });
      });
    });
    return c;
  }
  try { if (sessionStorage.getItem("sz-ev-note")) { sessionStorage.removeItem("sz-ev-note"); evBack = true; var h1 = $(".sz-cartpage h1"); if (h1) h1.insertAdjacentHTML("afterend", '<p class="sz-cart__text">' + NOTE_EV + "</p>"); } } catch (e) {}
  function renderCart(cart) {
    cart = dropEnded(cart);
    // lines keep the place they are shown in (the original adds new lines at the bottom), whatever order the store returns
    var pos = (lastCart.items || []).map(function (it) { return it.id; }), at = function (it) { var i = pos.indexOf(it.id); return i < 0 ? 1e9 : i; };
    if (cart.items) cart.items = cart.items.slice().sort(function (a, b) { return at(a) - at(b); });
    lastCart = cart;
    $$("[data-cart-count]").forEach(function (n) { n.textContent = cart.item_count > 0 ? cart.item_count : ""; });
    if (!cbody) return;
    var note = evNote ? '<p class="sz-cart__text">' + NOTE_EV + "</p>" : "";
    if (!cart.items || !cart.items.length) {
      cbody.innerHTML = '<div class="sz-cart__content"><p class="sz-cart__ctitle sz-cart__ctitle--empty">Prekių krepšelis yra tuščias</p>' + note + '<ul class="sz-cart__list"></ul></div>';
      return;
    }
    var h = '<div class="sz-cart__content"><p class="sz-cart__ctitle">Prekių krepšelis</p>' + note + '<ul class="sz-cart__list">';
    cart.items.forEach(function (it) {
      var variant = it.product_has_only_default_variant || !it.variant_title ? "" : '<p class="sz-cart__text">' + esc(it.variant_title) + "</p>";
      var src = SRC[it.id] || (SRC[it.id] = imgW(it.image, 375));
      var qpw = isDigital(it) ? "" : '<div class="sz-cart__qpw"><p class="sz-cart__qty"><span class="sz-cq"><button type="button" class="sz-cq__btn" data-cq="-1" aria-label="Mažinti kiekį">' + ICON_MINUS + "</button>" +
        '<input class="sz-cq__amount" disabled value="' + it.quantity + '" aria-label="Kiekis"><button type="button" class="sz-cq__btn" data-cq="1" aria-label="Didinti kiekį">' + ICON_PLUS + "</button></span></p></div>";
      // like the original, the line shows the unit price; only the total is multiplied
      h += '<li class="sz-cart__item" data-key="' + esc(it.key) + '"><img class="sz-cart__img" src="' + esc(src) + '" alt="' + esc(it.product_title) + '" width="64" height="64" loading="lazy">' +
        '<div class="sz-cart__cw"><p class="sz-cart__title">' + esc(it.product_title) + "</p>" + variant + qpw + "</div>" +
        '<div class="sz-cart__rc"><button type="button" class="sz-cart__rm" data-cq="0" aria-label="Pašalinti">' + ICON_TRASH + '</button><div class="sz-cart__pc"><p class="sz-cart__text sz-cart__price">' + eur(it.final_price) + "</p></div></div></li>";
    });
    h += '</ul></div><div class="sz-cart__footer"><p class="sz-cart__title sz-cart__title--slot">Iš viso: <span>' + eur(cart.total_price) + "</span></p>" +
      '<p class="sz-cart__text sz-cart__info"><span>Pristatymas apskaičiuojamas atsiskaitant</span></p>' +
      '<button type="button" class="sz-cart__checkout" data-checkout>Pereiti prie apmokėjimo</button>' +
      '<p class="sz-cart__text sz-cart__centered">' + ICON_LOCK + "<span>Saugus apmokėjimas</span></p></div>";
    cbody.innerHTML = h;
  }
  function getCart() { return fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function fetchCart() { return getCart().then(function (c) { if (!cartN) renderCart(c); return c; }); }
  function post(url, body) {
    return fetch(ROOT + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  // requests run one after another; fn resolves to the store's cart (on an error the store's cart is fetched again)
  function sync(fn, done) {
    cartN++;
    cartQ = cartQ.then(fn).then(function (c) { if (done) done(); if (!--cartN) renderCart(c); },
      function () { if (done) done(); if (!--cartN) fetchCart().catch(function () {}); });
  }
  // the cart once line `id` (variant) has quantity q; nl = the new line when it is not in the cart yet
  function expected(id, q, nl) {
    var c = { items: [], item_count: 0, total_price: lastCart.total_price || 0 }, hit = false;
    (lastCart.items || []).forEach(function (it) {
      var n = it;
      if (it.id === id) { hit = true; n = {}; for (var k in it) n[k] = it[k]; c.total_price += (q - it.quantity) * it.final_price; n.quantity = q; n.final_line_price = q * it.final_price; }
      if (n.quantity > 0) { c.items.push(n); c.item_count += n.quantity; }
    });
    if (!hit && nl && q > 0) { nl.quantity = q; nl.final_line_price = q * nl.final_price; c.items.push(nl); c.item_count += q; c.total_price += nl.final_line_price; }
    return c;
  }
  var cdT;
  function openCart(skipFetch) {
    if (!cd) { location.href = ROOT + "cart"; return; }
    clearTimeout(cdT); cd.classList.remove("is-leaving");
    // mobile: like the original the page jumps to the top and the panel covers the header's last pixel row
    if (window.innerWidth <= 920) window.scrollTo(0, 0);
    var top = $("[data-sz-top]");
    if (top) cd.style.setProperty("--cd-top", Math.max(0, top.getBoundingClientRect().bottom - 1) + "px");
    document.documentElement.style.overflow = "hidden";
    if (cd.hidden) {
      cd.hidden = false; cd.classList.add("is-entering");
      requestAnimationFrame(function () { requestAnimationFrame(function () { cd.classList.remove("is-entering"); }); });
    }
    if (!skipFetch) fetchCart().catch(function () {});
  }
  // like the original: the page scrolls again at once, the overlay goes at once, the panel slides out
  function closeCart() {
    if (!cd || cd.hidden || cd.classList.contains("is-leaving")) return;
    evNote = false;
    document.documentElement.style.overflow = "";
    cd.classList.add("is-leaving");
    cdT = setTimeout(function () { cd.hidden = true; cd.classList.remove("is-leaving"); }, 400);
  }
  try { var cj = $("[data-cart-json]"); if (cj) renderCart(JSON.parse(cj.textContent)); } catch (e) {}
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openCart(); }); });
  if (cd) {
    cd.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
      if (e.target.closest("[data-checkout]")) {
        // the page may have stayed open past midnight: an ended ticket is dropped first (and shown); queued changes finish
        TODAY = vilniusToday();
        if ((lastCart.items || []).some(isEnded)) { renderCart(lastCart); return; }
        cartQ.then(function () { location.href = ROOT + "checkout"; });
        return;
      }
      var b = e.target.closest("[data-cq]");
      if (!b) return;
      var it = lastCart.items[$$(".sz-cart__item", cbody).indexOf(b.closest(".sz-cart__item"))], d = +b.getAttribute("data-cq");
      if (!it) return;
      var q = d === 0 ? 0 : Math.max(0, it.quantity + d);
      renderCart(expected(it.id, q));
      sync(function () { return post("cart/change.js", { id: it.key || it.id, quantity: q }); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !cd.hidden) closeCart(); });
  }
  /* the /cart page form (Atnaujinti / Pereiti prie apmokėjimo): the page may have stayed open past midnight since the store
     drew it, so an ended ticket is removed first and the page drawn again with the note instead of going on */
  var cpf = $(".sz-cartpage form");
  if (cpf) cpf.addEventListener("submit", function (e) {
    TODAY = vilniusToday();
    if (!(lastCart.items || []).some(isEnded)) return;
    e.preventDefault();
    evBack = false; // (a user's submit, so the reload cannot loop)
    renderCart(lastCart);
  });
  window.SZ = window.SZ || {};
  window.SZ.openCart = openCart;

  /* Back/Forward from the browser's page cache: the page comes back as it was left, so close what was open (menu, cart
     drawer, lightbox) and give the page its scrolling back; the cart may have changed on the other page */
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    menuClose(true);
    if (cd && !cd.hidden) { clearTimeout(cdT); cd.hidden = true; cd.classList.remove("is-entering", "is-leaving"); document.documentElement.style.overflow = ""; }
    if (lbOpen()) lbClose();
    TODAY = vilniusToday(); // (the day may have changed: an ended ticket leaves the cart)
    fetchCart().catch(function () {});
  });

  /* add to cart (Shopify AJAX cart) */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add]");
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.getAttribute("data-simple") !== "1") { location.href = b.getAttribute("data-url"); return; }
    if (b.disabled || b.classList.contains("is-loading")) return;
    var qtyEl = b.closest("form") && b.closest("form").querySelector("[name=quantity]");
    var id = +b.getAttribute("data-add"), qty = qtyEl ? Math.min(250, Math.max(1, +qtyEl.value || 1)) : 1;
    var digital = b.getAttribute("data-digital") === "1", vt = b.getAttribute("data-vtitle");
    var line = (lastCart.items || []).filter(function (it) { return it.id === id; })[0];
    if (qtyEl) qtyEl.value = 1; // the original resets the picker after adding
    var add = function () { return post("cart/add.js", { items: [{ id: id, quantity: qty }] }); };
    if (!cd) { add().then(function () { location.href = ROOT + "cart"; }, function () { location.href = b.getAttribute("data-url"); }); return; }
    // a digital product is bought once: adding it again leaves the line at 1 (only added when the store's cart lacks it)
    if (digital) { qty = 1; if (line) { openCart(); return; } }
    if (b.getAttribute("data-img") && !SRC[id]) SRC[id] = b.getAttribute("data-img");
    renderCart(expected(id, (line ? line.quantity : 0) + qty, { id: id, key: "", product_title: b.getAttribute("data-name") || "", variant_title: vt || null, product_has_only_default_variant: !vt,
      image: "", final_price: +b.getAttribute("data-unit") || 0, requires_shipping: !digital, gift_card: false, product_type: digital ? VIDEO : "" }));
    openCart(true);
    b.classList.add("is-loading");
    sync(function () {
      return (digital ? getCart() : Promise.resolve(null)).then(function (c) {
        return c && c.items.some(function (it) { return it.id === id; }) ? c : add().then(getCart);
      });
    }, function () { b.classList.remove("is-loading"); });
  }, true);

  /* links inside the site open in the same tab (owner request 2026-10-23; gen.py drops the original's new-tab targets),
     also the ones the theme does not draw: Shopify's cookie banner ("Privatumo politikoje") and product/page texts whose
     link an editor set to open in a new window. Links to other sites keep their new tab */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[target=_blank]");
    if (a && a.host === location.host && a.protocol === location.protocol) a.removeAttribute("target");
  }, true);

  window.SZ = window.SZ || {};
  window.SZ.$ = $; window.SZ.$$ = $$;
})();
